import { useState, useEffect } from 'react'
import { MoneyCollectOutlined, ShareAltOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import PageHeading from '../../components/PageHeading';
import { debounce } from 'lodash';
import {
  message,
  Table,
  Popconfirm,
  Button,
  Input
} from 'antd';
import axiosInstance from '../../utils/axios';
import { dateFormatmicroSecond } from '../../utils/dateFormats';

const getMediaPath = (fullUrl) => {
  if (!fullUrl) return '';
  try {
    const url = new URL(fullUrl);
    const index = url.pathname.indexOf('mediafiles');
    if (index !== -1) {
      return url.pathname.substring(index);
    }
    return url.pathname;
  } catch (e) {
    const index = fullUrl.indexOf('mediafiles');
    return index !== -1 ? fullUrl.substring(index) : fullUrl;
  }
};

const TicketSnapshots = () => {
  const [bookings, setBookings] = useState({
    results: []
  });

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  useEffect(() => {
    const delayFetch = debounce(() => {
      fetchData();
    }, 550); // 550ms debounce

    delayFetch();

    return () => delayFetch.cancel();

    // eslint-disable-next-line
  }, [page, search]);

  const shareTicket = async (record) => {
    try {
      const response = await axiosInstance.post(`booking/share-missed-ticket/`, record);
      alert("Mail send");
    } catch (err) {
      alert("Cannot send mail");
    }
  }

  const columns = [
    {
      title: 'QR Code',
      key: 'qr_code',
      render: (_, record) => {
        const qrSrc = getMediaPath(record.qr_code);
        return (
          <div className="qr-wrapper">
            <button className="qr-share-btn" onClick={() => shareTicket(record)}>
              <ShareAltOutlined />
            </button>
            <img
              src={`${process.env.REACT_APP_MEDIA_URL}${qrSrc}`}
              alt="qr code"
              width={80}
              height={80}
            />
          </div>
        )
      }
    },
    {
      title: 'Movie',
      key: 'movie',
      render: (_, record) => record.movie_name,
    },
    {
      title: 'Theatre',
      key: 'theatre',
      render: (_, record) => record.theatre_name,
    },
    {
      title: 'Screen',
      key: 'screen',
      render: (_, record) => record.screen_name,
    },
    {
      title: 'Show Date & Time',
      key: 'showtime',
      render: (_, record) =>
        `${record.show_date} - ${record.show_time}`,
    },
    {
      title: 'Booked at',
      key: 'created_at',
      render: (_, record) => dateFormatmicroSecond(record.created_at),
    },
    {
      title: 'Booked By',
      key: 'booked_by',
      render: (_, record) => record.booked_by,
    },
    {
      title: 'Amount',
      key: 'amount',
      render: (_, record) => `${record.amount}`,
    },
    {
      title: 'Seats (section - block - row - position - number)',
      key: 'seats',
      render: (_, record) =>
        record.seats.length > 0 ? (
          <ul style={{ paddingLeft: 16, margin: 0 }}>
            {record.seats.map(seat => (
              <li key={seat.id}>
                {seat.section} - {seat.block} - {seat.row} - {seat.position} - {seat.number}
              </li>
            ))}
          </ul>
        ) : (
          `Order #${record.id}`
        ),
    },
    {
      title: 'Verified',
      key: 'status',
      render: (_, record) => record.is_verified === true ? <div style={{ padding: "5px", height: "30px", backgroundColor: "green" }}>Verified</div> : <div style={{ padding: "5px", height: "30px", backgroundColor: "orange" }}>Non Verified</div>
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'actions',
      render: (_, record) => record.restricted ? null : (
        <>
          <Popconfirm
            title="Delete"
            description="Deleting ticket may change report data. Are you sure want to delete this ticket?"
            onConfirm={() => confirm(record.id)}
            onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </>
      )
    },
  ];


  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`booking/ticket-snapshots/?page=${page}&search=${search}`);
      setBookings(response.data);
    } catch (error) {
      message.error("Failed to fetch shows");
    } finally {
      setLoading(false);
    }
  };

  const cancel = () => message.info('Cancelled');

  const confirm = async (id) => {
    try {
      await axiosInstance.delete(`booking/share-missed-ticket/${id}/`);
      message.success("Deleted successfully");
      fetchData();
    } catch (err) {
      message.error("Cannot delete");
    }
  };

  return (
    <div className='dashboard'>
      <PageHeading name="Paid Tickets" icon={<MoneyCollectOutlined />} />
      <small>In case customer lost ticket or didnt recieve email - (hover qr to share) </small>
      <Input
        placeholder="Search here"
        prefix={<SearchOutlined />}
        style={{ width: "190px" }}
        onChange={(e) => setSearch(e.target.value)}
      />
      <Table
        dataSource={bookings.results}
        loading={loading}
        columns={columns}
        rowKey="id"
        scroll={{ x: 'max-content' }}
        pagination={{
          current: page,
          pageSize: 20,
          total: bookings.count,
          onChange: (newPage, _) => {
            setPage(newPage);
          }
        }}
      />
    </div>
  )
}

export default TicketSnapshots;
